export const buildRange = (end: number, start = 1, step = 1): number[] => {
  const range = [] as number[];
  for (let i = start; i <= end; i += step) {
    range.push(i);
  }
  return range;
};
